import { create } from 'zustand';

import LocalStorageManager from '../../services/LocalStorageManager';

const SPOOKY_MODE_STORAGE_KEY = 'spooky-mode-enabled';

const OCTOBER = 9;
const SEASON_START_DAY = 25;

interface SpookyModeStore {
  available: boolean;
  enabled: boolean;
  toggle: () => void;
}

const readEnabled = () => {
  try {
    return LocalStorageManager.read(SPOOKY_MODE_STORAGE_KEY, true) !== false;
  } catch {
    return true;
  }
};

export const useSpookyModeStore = create<SpookyModeStore>(set => ({
  available: true,
  enabled: readEnabled(),
  toggle: () =>
    set(state => {
      LocalStorageManager.write(SPOOKY_MODE_STORAGE_KEY, !state.enabled);
      return { enabled: !state.enabled };
    })
}));

export const disableSpookyMode = () => useSpookyModeStore.setState({ available: false });

export const isSpookySeason = (date = new Date()) => date.getMonth() === OCTOBER && date.getDate() >= SEASON_START_DAY;

const useSpookyMode = () => useSpookyModeStore(state => state.available && state.enabled) && isSpookySeason();

export default useSpookyMode;
